<ng-container *ngIf="user">
    <div class="d-wdgt-inline d-none d-md-block">
        <div class="clearfix text-right">
            <button class="btn btn-close" (click)="close()" type="button">
                <i class="icon icon-edponline-Bop-071 icon-2x" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</ng-container>
<div class="d-flex justify-content-center h-100" [ngClass]="{ 'logged-in-margin-top': user }">
    <div class="content-wrapper h-100">
        <div class="text-center custom-icon-wrapper">
            <i class="icon icon-edponline-magnifying error custom-icon"></i>
        </div>
        <div class="text-center">
            <p class="text-title">{{ "pt.edp.edponline.no.agreement.proposal.title" | translate }}</p>
            <p *ngIf="!ineligibleClient" class="text-description">{{ "pt.edp.edponline.no.agreement.proposal.description" | translate }}</p>
            <p *ngIf="ineligibleClient" class="text-description">
                {{ "pt.edp.edponline.no.agreement.proposal.ineligibility.description" | translate }}
            </p>

            <p class="text-helper">{{ "pt.edp.edponline.no.agreement.proposal.helper" | translate }}</p>
        </div>
        <div class="custom-buttom-wrapper">
            <button (click)="close()" class="custom-buttom">
                {{ "pt.edp.edponline.no.agreement.proposal.button.label" | translate }}
            </button>
        </div>
    </div>
</div>
